import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { ThresholdIndicator } from '../../../core/components/threshold-bar/indicators/ThresholdIndicator.js';
import { isDynamicNumeric, isStatic } from '../../../core/types/type-guards.js';
import { transformHistogramThresholdIntoIndicator } from '../../../core/utils/thresholds-to-indicator.js';
import { useHoveredThresholdIdState } from '../../hooks/store/selectors.js';
import { useHistogramThresholds } from '../../hooks/useHistogramThresholds.js';
import { useHistogramXScale } from '../../hooks/useHistogramXScale.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';

export const ThresholdIndicators = () => {
  const { width } = useGridPlotSize();
  const [leftScale, rightScale] = useHistogramYScales();
  const { xScale } = useHistogramXScale();
  const { leftThreshold, rightThreshold } = useHistogramThresholds();
  const hoveredThresholdId = useHoveredThresholdIdState();

  const thresholds = [...(leftThreshold ?? []), ...(rightThreshold ?? [])];

  return (
    <svg className={plotLayout}>
      {thresholds.map(({ color, data, strokeOnly, position, id }, index) => {
        const yScale = position === 'left' ? leftScale : rightScale;

        if (!yScale) {
          return null;
        }

        const indicatorData = transformHistogramThresholdIntoIndicator(
          data,
          width,
          yScale,
          xScale,
        );
        const isStrokeOnly =
          isStatic(data) || isDynamicNumeric(data) || strokeOnly;

        return (
          <ThresholdIndicator
            key={`threshold-indicator-${id}`}
            data={indicatorData}
            color={color}
            strokeOnly={isStrokeOnly}
            isActive={hoveredThresholdId === id}
          />
        );
      })}
    </svg>
  );
};
